export default __webpack_public_path__ + "static/media/step1.7ba15d77.png";